import {
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  Iterable1y3qizuf89iou as Iterable,
  Collection1k04j3hzsbod0 as Collection,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  LinkedHashMap_init_$Create$1p3p95clvi93w as LinkedHashMap_init_$Create$,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  LinkedHashSet_init_$Create$3qv13l7kzf0ni as LinkedHashSet_init_$Create$,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(ConcurrentMutableCollection, 'ConcurrentMutableCollection', VOID, VOID, [Iterable, Collection]);
initMetadataForClass(ConcurrentMutableIterator, 'ConcurrentMutableIterator');
initMetadataForClass(ConcurrentMutableMap, 'ConcurrentMutableMap', ConcurrentMutableMap_init_$Create$, VOID, [KtMutableMap]);
initMetadataForClass(ConcurrentMutableSet, 'ConcurrentMutableSet', ConcurrentMutableSet_init_$Create$, ConcurrentMutableCollection, [ConcurrentMutableCollection, KtMutableSet]);
//endregion
function ConcurrentMutableCollection$_get_size_$lambda_dssf9y(this$0) {
  return function () {
    return this$0.o18_1.m();
  };
}
function ConcurrentMutableCollection$contains$lambda(this$0, $element) {
  return function () {
    return this$0.o18_1.u1($element);
  };
}
function ConcurrentMutableCollection$containsAll$lambda(this$0, $elements) {
  return function () {
    return this$0.o18_1.v1($elements);
  };
}
function ConcurrentMutableCollection$isEmpty$lambda(this$0) {
  return function () {
    return this$0.o18_1.p();
  };
}
function ConcurrentMutableCollection$add$lambda(this$0, $element) {
  return function () {
    return this$0.o18_1.e($element);
  };
}
function ConcurrentMutableCollection$addAll$lambda(this$0, $elements) {
  return function () {
    return this$0.o18_1.n($elements);
  };
}
function ConcurrentMutableCollection$clear$lambda(this$0) {
  return function () {
    this$0.o18_1.d2();
    return Unit_instance;
  };
}
function ConcurrentMutableCollection$iterator$lambda(this$0) {
  return function () {
    return new ConcurrentMutableIterator(this$0.p18_1, this$0.o18_1.j());
  };
}
function ConcurrentMutableCollection(rootArg, del) {
  rootArg = rootArg === VOID ? null : rootArg;
  this.o18_1 = del;
  var tmp = this;
  tmp.p18_1 = rootArg == null ? this : rootArg;
}
protoOf(ConcurrentMutableCollection).m = function () {
  this.p18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableCollection$_get_size_$lambda_dssf9y(this)();
};
protoOf(ConcurrentMutableCollection).u1 = function (element) {
  this.p18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableCollection$contains$lambda(this, element)();
};
protoOf(ConcurrentMutableCollection).v1 = function (elements) {
  this.p18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableCollection$containsAll$lambda(this, elements)();
};
protoOf(ConcurrentMutableCollection).p = function () {
  this.p18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableCollection$isEmpty$lambda(this)();
};
protoOf(ConcurrentMutableCollection).e = function (element) {
  this.p18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableCollection$add$lambda(this, element)();
};
protoOf(ConcurrentMutableCollection).n = function (elements) {
  this.p18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableCollection$addAll$lambda(this, elements)();
};
protoOf(ConcurrentMutableCollection).d2 = function () {
  this.p18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  ConcurrentMutableCollection$clear$lambda(this)();
};
protoOf(ConcurrentMutableCollection).j = function () {
  this.p18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableCollection$iterator$lambda(this)();
};
function ConcurrentMutableIterator$hasNext$lambda(this$0) {
  return function () {
    return this$0.r18_1.k();
  };
}
function ConcurrentMutableIterator$next$lambda(this$0) {
  return function () {
    return this$0.r18_1.l();
  };
}
function ConcurrentMutableIterator$remove$lambda(this$0) {
  return function () {
    this$0.r18_1.c4();
    return Unit_instance;
  };
}
function ConcurrentMutableIterator(root, del) {
  this.q18_1 = root;
  this.r18_1 = del;
}
protoOf(ConcurrentMutableIterator).k = function () {
  this.q18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableIterator$hasNext$lambda(this)();
};
protoOf(ConcurrentMutableIterator).l = function () {
  this.q18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableIterator$next$lambda(this)();
};
protoOf(ConcurrentMutableIterator).c4 = function () {
  this.q18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  ConcurrentMutableIterator$remove$lambda(this)();
};
function ConcurrentMutableMap_init_$Init$($this) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var tmp$ret$0 = LinkedHashMap_init_$Create$();
  ConcurrentMutableMap.call($this, null, tmp$ret$0);
  return $this;
}
function ConcurrentMutableMap_init_$Create$() {
  return ConcurrentMutableMap_init_$Init$(objectCreate(protoOf(ConcurrentMutableMap)));
}
function ConcurrentMutableMap$_get_size_$lambda_nuyc4q(this$0) {
  return function () {
    return this$0.s18_1.m();
  };
}
function ConcurrentMutableMap$_get_entries_$lambda_dp7xtt(this$0) {
  return function () {
    return new ConcurrentMutableSet(this$0, this$0.s18_1.r());
  };
}
function ConcurrentMutableMap$_get_keys_$lambda_5gjoyr(this$0) {
  return function () {
    return new ConcurrentMutableSet(this$0, this$0.s18_1.b2());
  };
}
function ConcurrentMutableMap$_get_values_$lambda_tyvlyt(this$0) {
  return function () {
    return new ConcurrentMutableCollection(this$0, this$0.s18_1.c2());
  };
}
function ConcurrentMutableMap$containsKey$lambda(this$0, $key) {
  return function () {
    return this$0.s18_1.y1($key);
  };
}
function ConcurrentMutableMap$get$lambda(this$0, $key) {
  return function () {
    return this$0.s18_1.a2($key);
  };
}
function ConcurrentMutableMap$isEmpty$lambda(this$0) {
  return function () {
    return this$0.s18_1.p();
  };
}
function ConcurrentMutableMap$clear$lambda(this$0) {
  return function () {
    this$0.s18_1.d2();
    return Unit_instance;
  };
}
function ConcurrentMutableMap$put$lambda(this$0, $key, $value) {
  return function () {
    return this$0.s18_1.h2($key, $value);
  };
}
function ConcurrentMutableMap$putAll$lambda(this$0, $from) {
  return function () {
    this$0.s18_1.j2($from);
    return Unit_instance;
  };
}
function ConcurrentMutableMap$remove$lambda(this$0, $key) {
  return function () {
    return this$0.s18_1.i2($key);
  };
}
function ConcurrentMutableMap(rootArg, del) {
  rootArg = rootArg === VOID ? null : rootArg;
  this.s18_1 = del;
  var tmp = this;
  tmp.t18_1 = rootArg == null ? this : rootArg;
}
protoOf(ConcurrentMutableMap).m = function () {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableMap$_get_size_$lambda_nuyc4q(this)();
};
protoOf(ConcurrentMutableMap).r = function () {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableMap$_get_entries_$lambda_dp7xtt(this)();
};
protoOf(ConcurrentMutableMap).b2 = function () {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableMap$_get_keys_$lambda_5gjoyr(this)();
};
protoOf(ConcurrentMutableMap).c2 = function () {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableMap$_get_values_$lambda_tyvlyt(this)();
};
protoOf(ConcurrentMutableMap).y1 = function (key) {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableMap$containsKey$lambda(this, key)();
};
protoOf(ConcurrentMutableMap).a2 = function (key) {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableMap$get$lambda(this, key)();
};
protoOf(ConcurrentMutableMap).p = function () {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableMap$isEmpty$lambda(this)();
};
protoOf(ConcurrentMutableMap).d2 = function () {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  ConcurrentMutableMap$clear$lambda(this)();
};
protoOf(ConcurrentMutableMap).h2 = function (key, value) {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableMap$put$lambda(this, key, value)();
};
protoOf(ConcurrentMutableMap).j2 = function (from) {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  ConcurrentMutableMap$putAll$lambda(this, from)();
};
protoOf(ConcurrentMutableMap).i2 = function (key) {
  this.t18_1;
  // Inline function 'co.touchlab.stately.concurrency.synchronize' call
  return ConcurrentMutableMap$remove$lambda(this, key)();
};
function ConcurrentMutableSet_init_$Init$($this) {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var tmp$ret$0 = LinkedHashSet_init_$Create$();
  ConcurrentMutableSet.call($this, null, tmp$ret$0);
  return $this;
}
function ConcurrentMutableSet_init_$Create$() {
  return ConcurrentMutableSet_init_$Init$(objectCreate(protoOf(ConcurrentMutableSet)));
}
function ConcurrentMutableSet(rootArg, del) {
  ConcurrentMutableCollection.call(this, rootArg, del);
  this.w18_1 = del;
}
//region block: exports
export {
  ConcurrentMutableMap_init_$Create$ as ConcurrentMutableMap_init_$Create$4dg5nsu16v6w,
  ConcurrentMutableSet_init_$Create$ as ConcurrentMutableSet_init_$Create$18hqiopn1culi,
};
//endregion

